import LETTER from "@/constants/letter.js";
import { reduce, map, get } from "lodash";

const BLANK = "[ - ]";
const RECIPIENT_INFORMATIONS = LETTER.RECIPIENT_INFORMATIONS;
const REPLACEMENT_CLASSES = LETTER.REPLACEMENT_CLASSES;

export default {
    data() {
        return {
            previousRecipients: [],
            noEditMessage: "Placeholder: Non-editable."
        };
    },
    methods: {
        setNamesElement(message, clientNameOnly = true) {
            const replacePlaceholders = (
                message,
                placeholders,
                replaceAll = false
            ) => {
                return reduce(
                    placeholders,
                    (msg, [placeholder, replacement]) => {
                        return replaceAll
                            ? msg.replaceAll(placeholder, replacement)
                            : msg.replace(placeholder, replacement);
                    },
                    message
                );
            };

            const basicReplacements = [
                ["{RECIPIENT_FIRST_NAME}", "<span class='first-names'></span>"],
                ["{RECIPIENT_LAST_NAME}", "<span class='last-names'></span>"]
            ];

            if (clientNameOnly) {
                return replacePlaceholders(message, basicReplacements);
            }

            const fullReplacements = [
                [
                    "{RECIPIENT_FIRST_NAME} {RECIPIENT_LAST_NAME}",
                    `<span class='${REPLACEMENT_CLASSES.FULL_NAME}' contenteditable='false' title="${this.noEditMessage}" ></span>`
                ],
                [
                    "{RECIPIENT_FIRST_NAME}{RECIPIENT_LAST_NAME}",
                    `<span class='${REPLACEMENT_CLASSES.FULL_NAME}' contenteditable='false' title="${this.noEditMessage}" ></span>`
                ],
                [
                    "{RECIPIENT_LAST_NAME} {RECIPIENT_FIRST_NAME}",
                    `<span class='${REPLACEMENT_CLASSES.FULL_NAME_ALT}' contenteditable='false' title="${this.noEditMessage}" ></span>`
                ],
                [
                    "{RECIPIENT_LAST_NAME}{RECIPIENT_FIRST_NAME}",
                    `<span class='${REPLACEMENT_CLASSES.FULL_NAME_ALT}' contenteditable='false' title="${this.noEditMessage}" ></span>`
                ],
                ...map(REPLACEMENT_CLASSES, (className, key) => [
                    get(RECIPIENT_INFORMATIONS, key),
                    `<span class='${className}' contenteditable='false' title="${this.noEditMessage}" ></span>`
                ])
            ];

            return replacePlaceholders(message, fullReplacements, true);
        },
        handleRecipientChange(value, editableId) {
            const newValues = Array.from(
                value
                    .reduce((map, item) => {
                        if (!map.has(item.oriId)) map.set(item.oriId, item);
                        return map;
                    }, new Map())
                    .values()
            );
            let firstNames = [];
            let lastNames = [];

            // VET-4469 - For email statement modal can be opened from client module and at the same time the communication list is opened, some content of the communications are email content that has element <span id='first-names'></span>
            let parentEditableDiv = document.getElementById(editableId);
            let firstElem = parentEditableDiv.querySelector(".first-names");
            let lastElem = parentEditableDiv.querySelector(".last-names");

            this.receiverNames = "";
            for (const option of newValues) {
                if (!option.email || option.email === "") {
                    continue;
                }

                if (option.contact_type == "company") {
                    firstNames.push(option.name);
                } else {
                    firstNames.push(option.firstname);
                    lastNames.push(option.lastname);
                }
            }

            let joinFirstNames = firstNames.join(", ");
            let joinLastNames = lastNames.join(", ");
            this.receiverNames = joinFirstNames;

            if (newValues.length > 0) {
                firstElem ? (firstElem.innerHTML = joinFirstNames) : null;
                lastElem ? (lastElem.innerHTML = joinLastNames) : null;
            } else {
                firstElem
                    ? (firstElem.innerHTML = "{RECIPIENT_FIRST_NAME},")
                    : null;
                lastElem
                    ? (lastElem.innerHTML = "{RECIPIENT_LAST_NAME},")
                    : null;
            }

            this.message = document.getElementById("editable-div").innerHTML;
        },
        formatBody(rawBody = "") {
            const { name, email, phone } = this._setting.business;
            let body = rawBody;
            body = body.replaceAll("{CLINIC_PHONE}", phone);
            body = body.replaceAll("{CLINIC_EMAIL}", email);
            body = body.replaceAll("{CLINIC_NAME}", name);
            return body;
        },
        /**
         * @issue VET-8265
         * @param object recipient information
         * @param boolean allow company name to replace {RECIPIENT_FIRST_NAME} variable
         */
        handleRecipientChangeAlt(values, firstNameUseCompanyName = false) {
            const newValues = Array.from(
                values
                    .reduce((map, item) => {
                        if (!map.has(item.oriId)) map.set(item.oriId, item);
                        return map;
                    }, new Map())
                    .values()
            );
            const previousLength = this.previousRecipients.length;
            const currentLength = newValues.length;
            const removeStructures = currentLength < previousLength;
            const structureDifferences = previousLength - currentLength;

            this.previousRecipients = newValues;

            // Create empty structures if needed
            const emptyStruct = removeStructures
                ? Array.from({ length: structureDifferences }, () => ({}))
                : [];

            const newRecipients = [...newValues, ...emptyStruct];
            if (newRecipients.length == 0) {
                newRecipients.push({});
            }

            // Parse the HTML string into a Document
            const parser = new DOMParser();
            const doc = parser.parseFromString(this.message || "", "text/html");

            newRecipients.forEach((option, index) => {
                // Determine the recipient name
                const recipientName =
                    option.firstname ||
                    (firstNameUseCompanyName
                        ? option.fullname || option.fullName
                        : BLANK);
                option.recipientName = recipientName;

                // handling new recipient and removed recipient
                Object.entries(REPLACEMENT_CLASSES).forEach(
                    ([key, className]) => {
                        const selector =
                            index === 0
                                ? `.${className}`
                                : `.${className}_${index}`;
                        const spans = doc.body.querySelectorAll(selector);
                        const value = this.getWhichClassValue(
                            className,
                            option
                        );

                        if (spans.length > 0) {
                            if (index < currentLength) {
                                spans.forEach(span => {
                                    span.innerHTML = value;
                                });
                            } else {
                                if (index === 0) {
                                    spans.forEach(span => {
                                        span.innerHTML =
                                            RECIPIENT_INFORMATIONS[key];
                                    });
                                } else {
                                    // Remove spans and associated commas for removed recipients
                                    spans.forEach(span => {
                                        // Remove any preceding comma if present
                                        const previousSibling =
                                            span.previousSibling;
                                        if (
                                            previousSibling &&
                                            previousSibling.nodeType ===
                                                Node.TEXT_NODE
                                        ) {
                                            // Check if the text content is a comma (possibly with whitespace)
                                            if (
                                                previousSibling.textContent.trim() ===
                                                ","
                                            ) {
                                                previousSibling.remove();
                                            }
                                        }
                                        // Remove the span
                                        span.remove();
                                    });
                                }
                            }
                        } else if (index > 0) {
                            const previousSelector =
                                index > 1
                                    ? `.${className}_${index - 1}`
                                    : `.${className}`;
                            const previousSpans = doc.body.querySelectorAll(
                                previousSelector
                            );

                            previousSpans.forEach(previousSpan => {
                                previousSpan.insertAdjacentHTML(
                                    "afterend",
                                    `, <span class="${className}_${index}" contenteditable="false" title="${this.noEditMessage}" >${value}</span>`
                                );
                            });
                        }
                    }
                );
            });

            // Update the message property with the new HTML
            this.message = doc.body.innerHTML;
        },
        getWhichClassValue(className, option) {
            switch (className) {
                case REPLACEMENT_CLASSES.FULL_NAME:
                    return `${option.recipientName || BLANK} ${
                        option.lastname || BLANK
                    }`;
                case REPLACEMENT_CLASSES.FULL_NAME_ALT:
                    return `${option.lastname || BLANK} ${
                        option.recipientName || BLANK
                    }`;
                case REPLACEMENT_CLASSES.FIRST_NAME:
                    return option.recipientName;
                case REPLACEMENT_CLASSES.LAST_NAME:
                    return option.lastname || BLANK;
                case REPLACEMENT_CLASSES.COMPANY:
                    return option.contact_type === "business"
                        ? option.fullname || option.fullName
                        : BLANK;
                case REPLACEMENT_CLASSES.ACCOUNT:
                    return option.account || option.account_no || BLANK;
                case REPLACEMENT_CLASSES.ADDRESS:
                    return option.address || BLANK;
                case REPLACEMENT_CLASSES.BIRTHDATE:
                    return option.birthdate || BLANK;
                case REPLACEMENT_CLASSES.COUNTRY:
                    return option.country || BLANK;
                case REPLACEMENT_CLASSES.ZIPCODE:
                    return option.zipcode || BLANK;
                case REPLACEMENT_CLASSES.SALUTATION:
                    return option.salutation || BLANK;
                case REPLACEMENT_CLASSES.CITY:
                    return option.city || BLANK;
                case REPLACEMENT_CLASSES.PHONE:
                    return option.contact_type === "business"
                        ? option.phone || option.work || BLANK
                        : option.phone || BLANK;
                case REPLACEMENT_CLASSES.EMAIL:
                    return option.email || BLANK;
                case REPLACEMENT_CLASSES.FAX:
                    return option.fax || BLANK;
                case REPLACEMENT_CLASSES.HOME:
                    return option.home || BLANK;
                case REPLACEMENT_CLASSES.MOBILE:
                    return option.mobile || BLANK;
                case REPLACEMENT_CLASSES.STATE:
                    return option.state || BLANK;
                case REPLACEMENT_CLASSES.TITLE:
                    return option.title || BLANK;
                case REPLACEMENT_CLASSES.WORK:
                    return option.work || BLANK;
            }
        }
    }
};
